const MediaPlayerWrapper = (__CLIENT__)
    ? require('./media-player-wrapper')
    : require('./player-container');
require('./media-player-wrapper.less');

module.exports = MediaPlayerWrapper;
